import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { StorageService } from 'app/storageprovider';
import { Utility } from 'app/_service/utility';
import { Unsubscribable } from 'rxjs';
import { RankedVideosService } from '../../_service/video/ranked-videos.services';

@Component({
  selector: 'app-top-ranked-videos',
  templateUrl: './top-ranked-videos.component.html',
  styleUrls: ['./top-ranked-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TopRankedVideosComponent implements OnInit {
  @Input()
  cid;
  @Input()
  videos = [];

  @Input()
  title;

  @Input()
  moreLink;

  @Input()
  fixed = true;

  // screenType = ScreenSize;
  // screenSize;
  isDark = false;

  private subscriptions:Array<Unsubscribable> = [];
  constructor(
   // private _windowService: WindowService,
    private _cd:ChangeDetectorRef,
    private _rankedVideosService: RankedVideosService,
    private _storage: StorageService,
    private _utility:Utility
  ) {
  
  }

  ngOnInit() {
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"] || "1") ;
    this.subscriptions.push(
    this._rankedVideosService.rankedVideosSource$.subscribe(res => {
      const l = res.find(r => r.cid === this.cid);
      if (l) {
        this.videos = l.items;
        this._cd.detectChanges();
      }
    }),

    this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
      if (theme == "dark") {
        this.isDark = true;
      }
      else {
        this.isDark = false;
      }
      this._cd.detectChanges();
    }));
  }
}
